var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "hot-container" },
    [
      _c("navbar", { attrs: { active: "hot" } }),
      _vm._v(" "),
      _c("list"),
      _vm._v(" "),
      _c("back-to-top", {
        attrs: {
          "custom-style": _vm.myBackToTopStyle,
          "visibility-height": 300,
          "back-position": 0,
          "transition-name": "fade",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }